export class Chat {

    constructor() {
        this.client_30s = 0;
        this.tmp_title = document.title;
        this.flag_title = 1;
        this.config_chat_30s = {};
        this.flag_completed = 0;
        this.id_admin = undefined;
        this.secret_admin = undefined;
        this.check_status_chat_30s = "";
        this.status_chat_30s = "";
        this.check_height_chat_30s = 0;
        this.check_action_chat_30s = 0;
        this.check_purle_chat_30s = 0;
        this.check_position_chat_30s = "left";
        this.latitude_chat30s = 0;
        this.longitude_chat30s = 0;
        this.purple = {};
        this.popup_height = 0;
        this.height_chat_30s = 0;
        this.lightGallery = {};
        this.check_focus = 0;
        this.title;
        this.change_viewport = false;
        this.opt_mouse = {};
        this.slide_chat = "";
    }

    init() {
      this.client_30s = this.getCookie30s("client_30s");
      if (window.innerWidth < 500 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          this.config_chat_30s.device = "mobile";
          this.config_chat_30s.purple_width = "100";
          this.config_chat_30s.type = "full";
          this.config_chat_30s.width = window.innerWidth;
          this.config_chat_30s.height = window.innerHeight;
      } else {
          this.config_chat_30s.device = "pc";
          this.config_chat_30s.purple_width = "200";
          this.config_chat_30s.type = "default";
          this.config_chat_30s.width = "330";
          this.config_chat_30s.height = "370";
      }
      this.config_chat_30s.width = parseInt(this.config_chat_30s.width);
      this.config_chat_30s.height = parseInt(this.config_chat_30s.height);

      if (typeof this.id_admin == "undefined") {
          this.id_admin = "";
      }
      if (typeof this.secret_admin == "undefined") {
          this.secret_admin = "";
      }

      this.config_chat_30s.check_purle = 0;
      this.config_chat_30s.check_position = "left";
      this.config_chat_30s.check_position_purple = "bottom_left";
      this.config_chat_30s.status_3rth = 0;
      this.config_chat_30s.check_position_purple_customize = "";

      this.opt_mouse.hold = 0;

      this.slide_chat += "<div onmousedown='mouse_down_left(event)' class='slide_chat' id='slide_left' style='position:absolute;top:0px;left:0px;height:100%;width:10px;z-index:1;cursor:w-resize'></div>";
      this.slide_chat += "<div onmousedown='mouse_down_right(event)' class='slide_chat' id='slide_right' style='position:absolute;top:0px;right:0px;height:100%;width:10px;z-index:1;cursor:e-resize'></div>";
    }

    getCookie30s(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        var rand = Math.random();
        this.setCookie30s(cname, rand, 1);
        return rand;
    }

    setCookie30s(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1e3);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    receiveMessageLiveChat(msg) {
        var self = this;
        var message_chat_30s = msg.data;
        var action_chat_30s = message_chat_30s.action;
        if (
            action_chat_30s == "last_token" ||
            action_chat_30s == "close_chat" ||
            action_chat_30s == "open_link" ||
            action_chat_30s == "size_iframe" ||
            action_chat_30s == "show_chat_gallery" ||
            action_chat_30s == "close_chat_gallery" ||
            action_chat_30s == "location" ||
            action_chat_30s == "call30s"
        ) {
            this.status_chat_30s = message_chat_30s.status;
            if (this.change_viewport == false && this.status_chat_30s == "open") {
                this.change_viewport = true;
                document.querySelectorAll('meta[name="viewport"]').forEach(function (viewportTag) {
                    viewportTag.content = viewportTag.content.replace(/,\s*user-scalable=(.*)/, "") + ", user-scalable=no";
                });
            }
            if (action_chat_30s == "last_token") {
                if (typeof Storage !== "undefined") {
                    localStorage.setItem("last_token", message_chat_30s.token);
                }
            } else if (action_chat_30s == "close_chat" && this.lightGallery.status != "show") {
                this.check_position_chat_30s = message_chat_30s.position;
                this.purple = message_chat_30s.purple;
                this.popup_height = message_chat_30s.popup_height;
                this.height_chat_30s = message_chat_30s.height;
                var hide = message_chat_30s.hide;
                if (this.config_chat_30s.width > 0) {
                    document.getElementById("support_chat_30s").style.height = this.height_chat_30s + "px";
                    document.getElementById("support_chat_30s").setAttribute("hide", hide);
                }
                if (this.check_status_chat_30s == "open") {
                    this.status_chat_30s = "close";
                }
                if (this.purple.length < 4) {
                }
                if (this.status_chat_30s == "close") {
                    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        document.getElementsByTagName("body")[0].style.position = null;
                    }
                } else {
                    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        document.getElementsByTagName("body")[0].style.position = "fixed";
                    }
                }
                document.getElementById("popup_chat_30s").style.display = "none";
                if (this.status_chat_30s == "open") {
                    document.getElementById("support_chat_30s").style.bottom = "-0px";
                } else {
                    if (this.purple.length > 4) {
                        this.check_purle_chat_30s = 1;
                        if (message_chat_30s.purple_size != "") {
                            document.getElementById("purple_chat_30s").style.width = message_chat_30s.purple_size;
                            document.getElementById("purple_chat_30s").style.height = "auto";
                            document.getElementById("purple_chat_30s").style.maxWidth = "none";
                            document.getElementById("purple_chat_30s").style.maxHeight = "none";
                        }
                        document.getElementById("support_chat_30s").style.opacity = "0";
                        document.getElementById("support_chat_30s").style.bottom = "-" + parseInt(this.height_chat_30s) + "px";
                        if (message_chat_30s.purple_config_chat_id > 0) {
                            document.getElementById("purple_chat_30s").innerHTML =
                                "<img style='max-width:100%;max-height:100%;border-radius:10px;' src='https://livechat.pavietnam.vn/data/" +
                                message_chat_30s.purple_config_chat_id +
                                "/images/purple/" +
                                this.config_chat_30s.purple_width +
                                "_" +
                                this.purple +
                                "' />";
                        } else {
                            document.getElementById("purple_chat_30s").innerHTML =
                                "<img style='max-width:100%;max-height:100%;border-radius:10px;' src='https://livechat.pavietnam.vn/images/purple/" + this.config_chat_30s.purple_width + "_" + this.purple + "' />";
                        }
                        document.getElementById("purple_chat_30s").style.display = "block";
                    } else {
                        document.getElementById("support_chat_30s").style.bottom = "-" + (parseInt(this.height_chat_30s) - hide) + "px";
                    }
                }
                if (document.getElementById("icon_chat_box") !== null) {
                    document.getElementById("icon_chat_box").style.display = "none";
                }
                document.getElementById("bg_chat_30s").style.display = "none";
            } else if (action_chat_30s == "open_link") {
                var type = message_chat_30s.type;
                var href = message_chat_30s.href;
                window.open(href);
            } else if (action_chat_30s == "size_iframe") {
                this.config_chat_30s.check_position = message_chat_30s.position;
                this.config_chat_30s.check_position_purple = message_chat_30s.position_purple;
                this.config_chat_30s.check_position_purple_customize = message_chat_30s.position_purple_customize;
                this.popup_height = message_chat_30s.popup_height;
                this.height_chat_30s = message_chat_30s.height;
                this.purple = message_chat_30s.purple;
                if (this.status_chat_30s == "close" && this.check_status_chat_30s != "open") {
                    document.getElementById("popup_chat_30s").style.display = "none";
                    if (this.purple.length > 4 && this.check_purle_chat_30s == 0) {
                        this.check_purle_chat_30s = 1;
                        if (message_chat_30s.purple_size != "") {
                            document.getElementById("purple_chat_30s").style.width = message_chat_30s.purple_size;
                            document.getElementById("purple_chat_30s").style.height = "auto";
                            document.getElementById("purple_chat_30s").style.maxWidth = "none";
                            document.getElementById("purple_chat_30s").style.maxHeight = "none";
                        }
                        document.getElementById("support_chat_30s").style.opacity = "0";
                        if (message_chat_30s.purple_config_chat_id > 0) {
                            document.getElementById("purple_chat_30s").innerHTML =
                                "<img style='max-width:100%;max-height:100%;border-radius:10px;' src='https://livechat.pavietnam.vn/data/" +
                                message_chat_30s.purple_config_chat_id +
                                "/images/purple/" +
                                this.config_chat_30s.purple_width +
                                "_" +
                                this.purple +
                                "' />";
                        } else {
                            document.getElementById("purple_chat_30s").innerHTML =
                                "<img style='max-width:100%;max-height:100%;border-radius:10px;' src='https://livechat.pavietnam.vn/images/purple/" + this.config_chat_30s.purple_width + "_" + this.purple + "' />";
                        }
                    }
                }
                var popup_chat_30s = "";
                popup_chat_30s += '<span id="popup-close">X</span>';
                popup_chat_30s += '<div class="popup-group">';
                popup_chat_30s +=
                    '<div id="popup_image_left" class="popup-image"><img src="https://livechat.pavietnam.vn/images/boy.png"></div><div class="popup-message"><div id="message-content" class="message-content">' +
                    message_chat_30s.note_welcome_popup +
                    '</div><div id="message-info" class="message-info">' +
                    message_chat_30s.note_title +
                    '</div></div><div id="popup_image_right" class="popup-image"><img src="https://livechat.pavietnam.vn/images/boy.png"></div></div>';
                popup_chat_30s += '<div class="popup-group">';
                popup_chat_30s +=
                    '<div id="popup_image_none_left" class="popup-image"></div><div class="popup-message"><input id="chat30s-input" onkeypress="popup_chat30s_message(event)" type="text" placeholder="' +
                    message_chat_30s.note_placeholder_popup +
                    '"></div><div id="popup_image_none_right" class="popup-image"></div></div>';
                popup_chat_30s += "";
                document.getElementById("popup_chat_30s").innerHTML = popup_chat_30s;
                var hide = message_chat_30s.hide;
                this.check_action_chat_30s = 1;
                if (this.config_chat_30s.from != "call30s") {
                    if (this.config_chat_30s.check_position == "left") {
                        document.getElementById("slide_left").style.display = "none";
                        document.getElementById("support_chat_30s").style.right = null;
                        document.getElementById("support_chat_30s").style.left = "3px";
                        document.getElementById("popup_chat_30s").style.left = "3px";
                        if (message_chat_30s.user_online_id < 1 && parseInt(message_chat_30s.skip_user_online_popup) > 0) {
                            document.getElementById("popup_image_right").style.display = "block";
                            document.getElementById("popup_image_left").style.display = "none";
                            document.getElementById("popup_image_none_right").style.display = "block";
                            document.getElementById("popup_image_none_left").style.display = "none";
                        }
                    } else if (this.config_chat_30s.check_position == "center") {
                        document.getElementById("support_chat_30s").style.right = null;
                        document.getElementById("support_chat_30s").style.left = "40%";
                    } else {
                        document.getElementById("slide_right").style.display = "none";
                        document.getElementById("support_chat_30s").style.left = null;
                        document.getElementById("support_chat_30s").style.right = "4px";
                    }
                    if (this.config_chat_30s.type == "full") {
                        document.getElementById("slide_left").style.display = "none";
                        document.getElementById("slide_right").style.display = "none";
                    }
                }
                if (this.config_chat_30s.check_position_purple == "-1") {
                    var arr_check_position_customize = this.config_chat_30s.check_position_purple_customize;
                    var arr_check_position_purple_customize = arr_check_position_customize.split(",");
                    var purple_top = parseInt(arr_check_position_purple_customize[0]);
                    var purple_right = parseInt(arr_check_position_purple_customize[1]);
                    var purple_bottom = parseInt(arr_check_position_purple_customize[2]);
                    var purple_left = parseInt(arr_check_position_purple_customize[3]);
                    var img_width = parseInt(arr_check_position_purple_customize[4]);
                    var img_height = parseInt(arr_check_position_purple_customize[5]);
                    var rate_width = Math.round((1e3 * parseInt(window.innerHeight)) / (purple_left + purple_right)) / 1e3;
                    var rate_height = Math.round((1e3 * parseInt(window.innerWidth)) / (purple_top + purple_bottom)) / 1e3;
                    document.getElementById("purple_chat_30s").style.left = purple_left * rate_width + "px";
                    document.getElementById("purple_chat_30s").style.top = purple_top * rate_height + "px";
                    document.getElementById("purple_chat_30s").style.bottom = (purple_bottom - img_height) * rate_height + "px";
                    document.getElementById("purple_chat_30s").style.right = (purple_right - img_width) * rate_width + "px";
                    if (parseInt(arr_check_position_purple_customize[0]) > parseInt(arr_check_position_purple_customize[2])) {
                        document.getElementById("purple_chat_30s").style.top = null;
                    } else {
                        document.getElementById("purple_chat_30s").style.bottom = null;
                    }
                    if (parseInt(arr_check_position_purple_customize[1]) > parseInt(arr_check_position_purple_customize[3])) {
                        document.getElementById("purple_chat_30s").style.right = null;
                    } else {
                        document.getElementById("purple_chat_30s").style.left = null;
                    }
                } else if (this.config_chat_30s.check_position_purple == "top_right") {
                    document.getElementById("purple_chat_30s").style.bottom = null;
                    document.getElementById("purple_chat_30s").style.left = null;
                    document.getElementById("purple_chat_30s").style.top = "10px";
                    document.getElementById("purple_chat_30s").style.right = "10px";
                } else if (this.config_chat_30s.check_position_purple == "bottom_left") {
                    document.getElementById("purple_chat_30s").style.top = null;
                    document.getElementById("purple_chat_30s").style.right = null;
                    document.getElementById("purple_chat_30s").style.bottom = "0px";
                    document.getElementById("purple_chat_30s").style.left = "0px";
                } else if (this.config_chat_30s.check_position_purple == "bottom_right") {
                    document.getElementById("purple_chat_30s").style.top = null;
                    document.getElementById("purple_chat_30s").style.left = null;
                    document.getElementById("purple_chat_30s").style.bottom = "10px";
                    document.getElementById("purple_chat_30s").style.right = "10px";
                } else if (this.config_chat_30s.check_position_purple == "center_left") {
                    document.getElementById("purple_chat_30s").style.bottom = null;
                    document.getElementById("purple_chat_30s").style.left = null;
                    document.getElementById("purple_chat_30s").style.top = "30%";
                    document.getElementById("purple_chat_30s").style.left = "10px";
                } else if (this.config_chat_30s.check_position_purple == "center_right") {
                    document.getElementById("purple_chat_30s").style.bottom = null;
                    document.getElementById("purple_chat_30s").style.left = null;
                    document.getElementById("purple_chat_30s").style.top = "30%";
                    document.getElementById("purple_chat_30s").style.right = "10px";
                } else {
                    document.getElementById("purple_chat_30s").style.bottom = null;
                    document.getElementById("purple_chat_30s").style.right = null;
                    document.getElementById("purple_chat_30s").style.top = "10px";
                    document.getElementById("purple_chat_30s").style.left = "10px";
                }
                if (this.check_action_chat_30s == 0 || this.check_action_chat_30s == 1) {
                    this.check_height_chat_30s = message_chat_30s.height;
                    this.config_chat_30s.width = message_chat_30s.width;
                    if (this.config_chat_30s.width > 0) {
                        document.getElementById("support_chat_30s").style.height = this.height_chat_30s + "px";
                        document.getElementById("support_chat_30s").style.width = this.config_chat_30s.width + 6 + "px";
                        document.getElementById("support_chat_30s").setAttribute("hide", hide);
                        document.getElementById("popup_chat_30s").style.bottom = hide + "px";
                        document.getElementById("popup_chat_30s").style.width = this.config_chat_30s.width + 50 + "px";
                        document.getElementById("popup_chat_30s").style.display = "block";
                    } else {
                        document.getElementById("support_chat_30s").style.height = this.height_chat_30s + "px";
                    }
                    if (this.status_chat_30s == "close" && this.check_status_chat_30s != "open") {
                        this.height_chat_30s = parseInt(this.height_chat_30s) - hide;
                        if (this.purple.length > 4) {
                            this.height_chat_30s = 999;
                        }
                        document.getElementById("support_chat_30s").style.bottom = "-" + this.height_chat_30s + "px";
                    } else {
                        document.getElementById("popup_chat_30s").style.display = "none";
                        document.getElementById("support_chat_30s").style.bottom = "0px";
                    }
                }
                if (message_chat_30s.phonebox == true) {
                    this.status_chat_30s = "open";
                    document.getElementById("support_chat_30s").style.top = "calc(50% - " + hide / 2 + "px)";
                    document.getElementById("support_chat_30s").style.left = "calc(50% - " + message_chat_30s.width / 2 + "px)";
                    document.getElementById("bg_chat_30s").style.display = "block";
                    document.getElementById("support_chat_30s").style.opacity = "1";
                    document.getElementById("support_chat_30s").style.height = "auto";
                } else {
                    document.getElementById("bg_chat_30s").style.display = "none";
                    document.getElementById("support_chat_30s").style.top = "unset";
                    document.getElementById("support_chat_30s").style.left = "unset";
                }
                if (message_chat_30s.user_online_id > 0 || parseInt(message_chat_30s.skip_user_online_popup) < 1 || this.purple.length > 5) {
                    document.getElementById("popup_chat_30s").style.display = "none";
                }
                document.getElementById("popup-close").addEventListener("click", function() {
                    this.popup_close_30s()
                });
            } else if (action_chat_30s == "show_chat_gallery") {
                this.lightGallery = { width_chat_30s: document.getElementById("support_chat_30s").style.width, height_chat_30s: document.getElementById("support_chat_30s").style.height, status: "show" };
                document.getElementById("support_chat_30s").style.width = "100%";
                document.getElementById("support_chat_30s").style.height = "100%";
            } else if (action_chat_30s == "close_chat_gallery") {
                this.lightGallery.status = "close";
                document.getElementById("support_chat_30s").style.width = this.lightGallery.width_chat_30s;
                document.getElementById("support_chat_30s").style.height = this.lightGallery.height_chat_30s;
            } else if (action_chat_30s == "location") {
                sendMessageLiveChat({ action: "location", latitude: this.latitude_chat30s, longitude: this.longitude_chat30s, user_online_id: message_chat_30s.user_online_id });
            } else if (action_chat_30s == "call30s") {
                document.getElementById("support_chat_30s").style.right = "initial";
            }
            if (this.config_chat_30s.status_3rth == 1 && this.status_chat_30s == "open" && document.getElementById("wellcome_chat")) {
                document.getElementById("wellcome_chat").style.display = "none";
            }
            if (this.config_chat_30s.status_3rth == 1 && this.status_chat_30s == "close" && this.purple.length < 5) {
                document.getElementById("support_chat_30s").style.opacity = "0";
                document.getElementById("support_chat_30s").style.bottom = "-1000px";
                document.getElementById("support_chat_30s").setAttribute("data-status", "close");
            }
        } else if (action_chat_30s == "notification") {
            this.check_focus = 1;
            this.title_scroller(message_chat_30s.msg);
        } else if (action_chat_30s == "popup_msg" && message_chat_30s.status == "close") {
            this.flag_title = 1;
            if (document.getElementById("popup_msg_30s") != null) {
                document.getElementById("popup_msg_30s").style.display = "block";
            }
            setInterval(function () {
                if (self.flag_title == 0) {
                    return false;
                }
                if (self.flag_title == 1) {
                    document.title = message_chat_30s.msg;
                    self.flag_title = 2;
                } else {
                    document.title = this.tmp_title;
                    self.flag_title = 1;
                }
            }, 1500);
        } else if (action_chat_30s == "message") {
            this.check_focus = 1;
            this.title_scroller(message_chat_30s.msg);
            if (this.status_chat_30s == "close" && message_chat_30s.quick_chat == 1) {
                document.getElementById("popup_chat_30s").style.display = "block";
                document.getElementById("message-content").innerHTML = message_chat_30s.msg;
                document.getElementById("message-info").innerHTML = message_chat_30s.fullname + " - " + message_chat_30s.date_send;
            }
        }
    }

    popup_close_30s() {
        document.getElementById("popup_chat_30s").style.display = "none";
    }

    title_scroller(text) {
        var self = this;
        if (this.check_focus != 1) {
            document.title = this.title;
            return false;
        }
        if (text == null || text.length < 1) {
            return false;
        }
        document.title = text;
        setTimeout(function () {
            self.title_scroller(text.substr(1) + text.substr(0, 1));
        }, 100);
    }

    purple_chat_30s() {
        this.check_status_chat_30s = "open";
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            document.getElementsByTagName("body")[0].style.position = "fixed";
        }
        document.getElementById("support_chat_30s").style.opacity = "1";
        document.getElementById("support_chat_30s").style.bottom = "0px";
        document.getElementById("purple_chat_30s").style.display = "none";
        this.sendMessageLiveChat({ action: "check_chat" });
    }

    mouse_down_left(e) {
        this.opt_mouse.hold = 1;
        this.opt_mouse.type = "left";
        document.getElementById("slide_left").style.width = "100px";
    }

    mouse_down_right(e) {
        this.opt_mouse.hold = 1;
        this.opt_mouse.type = "right";
        document.getElementById("slide_right").style.width = "100px";
    }

    popup_chat30s_message(e) {
        if (e.keyCode === 13) {
            this.sendMessageLiveChat({ action: "send_message", msg: document.getElementById("chat30s-input").value });
            document.getElementById("popup_chat_30s").style.display = "none";
            document.getElementById("chat30s-input").value = "";
        }
    }

    chat30s(arr_data) {
        var self = this;
        if (document.getElementById("popup_msg_30s") != null) {
            document.getElementById("popup_msg_30s").style.display = "none";
        }
        this.flag_title = 0;
        var timeout_30s = 50;
        if (this.flag_completed != 1) {
            timeout_30s = 2e3;
        }
        setTimeout(function () {
            self.config_chat_30s.from = "chat30s";
            if (self.purple.length < 5) {
                if (arr_data.width) {
                    document.getElementById("support_chat_30s").style.width = arr_data.width;
                }
                var chat_status = document.getElementById("support_chat_30s").getAttribute("data-status");
                if (chat_status == "open") {
                    document.getElementById("support_chat_30s").style.opacity = "0";
                    document.getElementById("support_chat_30s").setAttribute("data-status", "close");
                    document.getElementById("support_chat_30s").style.top = "unset";
                    document.getElementById("support_chat_30s").style.left = "unset";
                    document.getElementById("support_chat_30s").style.transform = "unset";
                } else {
                    document.getElementById("support_chat_30s").style.opacity = "1";
                    document.getElementById("support_chat_30s").setAttribute("data-status", "open");
                    document.getElementById("support_chat_30s").style.top = "unset";
                    document.getElementById("support_chat_30s").style.left = "unset";
                    document.getElementById("support_chat_30s").style.transform = "unset";
                }
                arr_data.action = "close";
                arr_data.from = "chat30s";
                self.sendMessageLiveChat(arr_data);
            }
        }, timeout_30s);
    }

    call30s(arr_data) {
        this.config_chat_30s.from = "call30s";
        arr_data.action = "call30s";
        this.sendMessageLiveChat(arr_data);
    }

    getLocationChat30s() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.showPosition);
        }
    }

    showPosition(position) {
        this.latitude_chat30s = position.coords.latitude;
        this.longitude_chat30s = position.coords.longitude;
    }

    check_device_apple() {
        var web_origin = window.location.origin;
        return false;
        if (web_origin.indexOf("sieuthimaychu.vn") > 0) {
            return false;
        }
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            return true;
        }
        return false;
    }

    sendMessageLiveChat(data) {
        var iframeWin = document.getElementById("ifr_chat").contentWindow;
        let script_30s = "live_chat_30s";
        let host_30s = "livechat.pavietnam.vn";
        if (document.getElementById("call_30s") !== null) {
            script_30s = "call_30s";
            host_30s = "callnow.pavietnam.vn";
        }
        if (document.getElementById(script_30s) !== null) {
            if (document.getElementById(script_30s).hasAttribute("data-host")) {
                host_30s = document.getElementById(script_30s).getAttribute("data-host");
            }
        }
        iframeWin.postMessage(data, "https://" + host_30s);
    }

    load() {
        this.init();
        var self = this;
        var section_30s = document.createElement("section");
        section_30s.setAttribute("style", "padding:0px;margin:0px");
        document.body.appendChild(section_30s);
        var section_call = "";
        var chat_lang = "none";
        var ref_token_detail = "";
        var ref_token = "";
        var call = "0";
        var show_call = "0";
        var script_30s = "live_chat_30s";
        var host_30s = "livechat.pavietnam.vn";
        if (document.getElementById("call_30s") !== null) {
            script_30s = "call_30s";
            host_30s = "callnow.pavietnam.vn";
        }
        if (document.getElementById(script_30s) !== null) {
            if (document.getElementById(script_30s).hasAttribute("data-host")) {
                host_30s = document.getElementById(script_30s).getAttribute("data-host");
            }
            if (document.getElementById(script_30s).hasAttribute("data-lang")) {
                chat_lang = document.getElementById(script_30s).getAttribute("data-lang");
                if (chat_lang == "vn") {
                    chat_lang = "vi";
                }
            }
            if (document.getElementById(script_30s).hasAttribute("data-hide")) {
                this.config_chat_30s.status_3rth = parseInt(document.getElementById(script_30s).getAttribute("data-hide"));
            }
            if (document.getElementById(script_30s).hasAttribute("data-call")) {
                call = parseInt(document.getElementById(script_30s).getAttribute("data-call"));
            }
            if (document.getElementById(script_30s).hasAttribute("ref_token")) {
                ref_token = document.getElementById(script_30s).getAttribute("ref_token");
            }
            if (document.getElementById(script_30s).hasAttribute("ref_token_detail")) {
                ref_token_detail = document.getElementById(script_30s).getAttribute("ref_token_detail");
            }
            if (document.getElementById(script_30s).hasAttribute("data-show-call")) {
                show_call = parseInt(document.getElementById(script_30s).getAttribute("data-show-call"));
            }
        }
        setTimeout(function () {
            var last_token = "";
            if (localStorage.last_token) {
                last_token = localStorage.last_token;
            }
            if (show_call == 1 && !check_device_apple()) {
                section_call =
                    "<style>.dmd-phone{position:fixed;visibility:hidden;background-color:transparent;width:48px;height:48px;cursor:pointer;z-index:200000!important;-webkit-backface-visibility:hidden;-webkit-transform:translateZ(0);-webkit-transition:visibility .5s;-moz-transition:visibility .5s;-o-transition:visibility .5s;transition:visibility .5s;right:30px;top:50%}.dmd-phone.dmd-show{visibility:visible}.dmd-phone.dmd-static{opacity:.6}.dmd-phone.dmd-hover,.dmd-phone:hover{opacity:1}.dmd-ph-circle{display:none;width:120px;height:120px;top:42.5px;left:42.5px;position:absolute;background-color:transparent;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;border:2px solid rgba(30,30,30,.4);border:2px solid #bfebfc 9;opacity:.1;-webkit-animation:dmd-circle-anim 1.2s infinite ease-in-out;-moz-animation:dmd-circle-anim 1.2s infinite ease-in-out;-ms-animation:dmd-circle-anim 1.2s infinite ease-in-out;-o-animation:dmd-circle-anim 1.2s infinite ease-in-out;animation:dmd-circle-anim 1.2s infinite ease-in-out;-webkit-transition:all .5s;-moz-transition:all .5s;-o-transition:all .5s;transition:all .5s;-webkit-transform-origin:50% 50%;-moz-transform-origin:50% 50%;-ms-transform-origin:50% 50%;-o-transform-origin:50% 50%;transform-origin:50% 50%}.dmd-phone.dmd-active .dmd-ph-circle{-webkit-animation:dmd-circle-anim 1.1s infinite ease-in-out!important;-moz-animation:dmd-circle-anim 1.1s infinite ease-in-out!important;-ms-animation:dmd-circle-anim 1.1s infinite ease-in-out!important;-o-animation:dmd-circle-anim 1.1s infinite ease-in-out!important;animation:dmd-circle-anim 1.1s infinite ease-in-out!important}.dmd-phone.dmd-static .dmd-ph-circle{-webkit-animation:dmd-circle-anim 2.2s infinite ease-in-out!important;-moz-animation:dmd-circle-anim 2.2s infinite ease-in-out!important;-ms-animation:dmd-circle-anim 2.2s infinite ease-in-out!important;-o-animation:dmd-circle-anim 2.2s infinite ease-in-out!important;animation:dmd-circle-anim 2.2s infinite ease-in-out!important}.dmd-phone.dmd-hover .dmd-ph-circle,.dmd-phone:hover .dmd-ph-circle{border-color:#bf202f;opacity:.5}.dmd-phone.dmd-green.dmd-hover .dmd-ph-circle,.dmd-phone.dmd-green:hover .dmd-ph-circle{border-color:#555;border-color:#baf5a7 9;opacity:.5}.dmd-phone.dmd-green .dmd-ph-circle{border-color:red;border-color:#bfebfc 9;opacity:.5}.dmd-phone.dmd-gray.dmd-hover .dmd-ph-circle,.dmd-phone.dmd-gray:hover .dmd-ph-circle{border-color:#ccc;opacity:.5}.dmd-phone.dmd-gray .dmd-ph-circle{border-color:#555;opacity:.5}.dmd-ph-circle-fill{display:none;width:80px;height:80px;top:62.5px;left:62.5px;position:absolute;background-color:#000;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;border:2px solid transparent;opacity:.1;-webkit-animation:dmd-circle-fill-anim 2.3s infinite ease-in-out;-moz-animation:dmd-circle-fill-anim 2.3s infinite ease-in-out;-ms-animation:dmd-circle-fill-anim 2.3s infinite ease-in-out;-o-animation:dmd-circle-fill-anim 2.3s infinite ease-in-out;animation:dmd-circle-fill-anim 2.3s infinite ease-in-out;-webkit-transition:all .5s;-moz-transition:all .5s;-o-transition:all .5s;transition:all .5s;-webkit-transform-origin:50% 50%;-moz-transform-origin:50% 50%;-ms-transform-origin:50% 50%;-o-transform-origin:50% 50%;transform-origin:50% 50%}.dmd-phone.dmd-active .dmd-ph-circle-fill{-webkit-animation:dmd-circle-fill-anim 1.7s infinite ease-in-out!important;-moz-animation:dmd-circle-fill-anim 1.7s infinite ease-in-out!important;-ms-animation:dmd-circle-fill-anim 1.7s infinite ease-in-out!important;-o-animation:dmd-circle-fill-anim 1.7s infinite ease-in-out!important;animation:dmd-circle-fill-anim 1.7s infinite ease-in-out!important}.dmd-phone.dmd-static .dmd-ph-circle-fill{-webkit-animation:dmd-circle-fill-anim 2.3s infinite ease-in-out!important;-moz-animation:dmd-circle-fill-anim 2.3s infinite ease-in-out!important;-ms-animation:dmd-circle-fill-anim 2.3s infinite ease-in-out!important;-o-animation:dmd-circle-fill-anim 2.3s infinite ease-in-out!important;animation:dmd-circle-fill-anim 2.3s infinite ease-in-out!important;opacity:0!important}.dmd-phone.dmd-hover .dmd-ph-circle-fill,.dmd-phone:hover .dmd-ph-circle-fill{background-color:rgba(240,95,160,.5);background-color:#bf202f 9;opacity:.75!important}.dmd-phone.dmd-green.dmd-hover .dmd-ph-circle-fill,.dmd-phone.dmd-green:hover .dmd-ph-circle-fill{background-color:rgba(0,0,0,.5);background-color:#baf5a7 9;opacity:.75!important}.dmd-phone.dmd-green .dmd-ph-circle-fill{background-color:red;opacity:.0!important}.dmd-phone.dmd-gray.dmd-hover .dmd-ph-circle-fill,.dmd-phone.dmd-gray:hover .dmd-ph-circle-fill{background-color:rgba(204,204,204,.5);opacity:.75!important}.dmd-phone.dmd-gray .dmd-ph-circle-fill{background-color:rgba(0,0,0,.3);opacity:.5!important}.dmd-ph-img-circle{width:40px;height:40px;top:0;left:0;-webkit-box-shadow:5px 5px 0 rgba(0,0,0,.05);-moz-box-shadow:5px 5px 0 rgba(0,0,0,.05);box-shadow:5px 5px 0 rgba(0,0,0,.05);border-radius:50%;box-sizing:content-box;position:absolute;background:rgba(30,30,30,1) url(https://callnow.pavietnam.vn/images/freecall.png) no-repeat center center;-webkit-background-size:80%;background-size:80%;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;border:2px solid transparent;opacity:1;-webkit-animation:dmd-circle-img-anim 1s infinite ease-in-out;-moz-animation:dmd-circle-img-anim 1s infinite ease-in-out;-ms-animation:dmd-circle-img-anim 1s infinite ease-in-out;-o-animation:dmd-circle-img-anim 1s infinite ease-in-out;animation:dmd-circle-img-anim 1s infinite ease-in-out;-webkit-transform-origin:50% 50%;-moz-transform-origin:50% 50%;-ms-transform-origin:50% 50%;-o-transform-origin:50% 50%;transform-origin:50% 50%}.dmd-phone.dmd-active .dmd-ph-img-circle{-webkit-animation:dmd-circle-img-anim 1s infinite ease-in-out!important;-moz-animation:dmd-circle-img-anim 1s infinite ease-in-out!important;-ms-animation:dmd-circle-img-anim 1s infinite ease-in-out!important;-o-animation:dmd-circle-img-anim 1s infinite ease-in-out!important;animation:dmd-circle-img-anim 1s infinite ease-in-out!important}.dmd-phone.dmd-static .dmd-ph-img-circle{-webkit-animation:dmd-circle-img-anim 0s infinite ease-in-out!important;-moz-animation:dmd-circle-img-anim 0s infinite ease-in-out!important;-ms-animation:dmd-circle-img-anim 0s infinite ease-in-out!important;-o-animation:dmd-circle-img-anim 0s infinite ease-in-out!important;animation:dmd-circle-img-anim 0s infinite ease-in-out!important}.dmd-phone.dmd-hover .dmd-ph-img-circle,.dmd-phone:hover .dmd-ph-img-circle{background-color:#bf202f}.dmd-phone.dmd-green.dmd-hover .dmd-ph-img-circle,.dmd-phone.dmd-green:hover .dmd-ph-img-circle{background-color:#f60}.dmd-phone.dmd-green .dmd-ph-img-circle{background-color:#d92e62!important;border:4px solid #FFF}.dmd-phone.dmd-gray.dmd-hover .dmd-ph-img-circle,.dmd-phone.dmd-gray:hover .dmd-ph-img-circle{background-color:#ccc}.dmd-phone.dmd-gray .dmd-ph-img-circle{background-color:#555}@-moz-keyframes dmd-circle-anim{0%{-moz-transform:rotate(0) scale(.5) skew(1deg);opacity:.1;-moz-opacity:.1;-webkit-opacity:.1;-o-opacity:.1}30%{-moz-transform:rotate(0) scale(.7) skew(1deg);opacity:.5;-moz-opacity:.5;-webkit-opacity:.5;-o-opacity:.5}100%{-moz-transform:rotate(0) scale(1) skew(1deg);opacity:.6;-moz-opacity:.6;-webkit-opacity:.6;-o-opacity:.1}}@-webkit-keyframes dmd-circle-anim{0%{-webkit-transform:rotate(0) scale(.5) skew(1deg);-webkit-opacity:.1}30%{-webkit-transform:rotate(0) scale(.7) skew(1deg);-webkit-opacity:.5}100%{-webkit-transform:rotate(0) scale(1) skew(1deg);-webkit-opacity:.1}}@-o-keyframes dmd-circle-anim{0%{-o-transform:rotate(0) kscale(.5) skew(1deg);-o-opacity:.1}30%{-o-transform:rotate(0) scale(.7) skew(1deg);-o-opacity:.5}100%{-o-transform:rotate(0) scale(1) skew(1deg);-o-opacity:.1}}@-moz-keyframes dmd-circle-fill-anim{0%{-moz-transform:rotate(0) scale(.7) skew(1deg);opacity:.2}50%{-moz-transform:rotate(0) -moz-scale(1) skew(1deg);opacity:.2}100%{-moz-transform:rotate(0) scale(.7) skew(1deg);opacity:.2}}@-webkit-keyframes dmd-circle-fill-anim{0%{-webkit-transform:rotate(0) scale(.7) skew(1deg);opacity:.2}50%{-webkit-transform:rotate(0) scale(1) skew(1deg);opacity:.2}100%{-webkit-transform:rotate(0) scale(.7) skew(1deg);opacity:.2}}@-o-keyframes dmd-circle-fill-anim{0%{-o-transform:rotate(0) scale(.7) skew(1deg);opacity:.2}50%{-o-transform:rotate(0) scale(1) skew(1deg);opacity:.2}100%{-o-transform:rotate(0) scale(.7) skew(1deg);opacity:.2}}@-moz-keyframes dmd-circle-img-anim{0%{transform:rotate(0) scale(1) skew(1deg)}10%{-moz-transform:rotate(-25deg) scale(1) skew(1deg)}20%{-moz-transform:rotate(25deg) scale(1) skew(1deg)}30%{-moz-transform:rotate(-25deg) scale(1) skew(1deg)}40%{-moz-transform:rotate(25deg) scale(1) skew(1deg)}50%{-moz-transform:rotate(0) scale(1) skew(1deg)}100%{-moz-transform:rotate(0) scale(1) skew(1deg)}}@-webkit-keyframes dmd-circle-img-anim{0%{-webkit-transform:rotate(0) scale(1) skew(1deg)}10%{-webkit-transform:rotate(-25deg) scale(1) skew(1deg)}20%{-webkit-transform:rotate(25deg) scale(1) skew(1deg)}30%{-webkit-transform:rotate(-25deg) scale(1) skew(1deg)}40%{-webkit-transform:rotate(25deg) scale(1) skew(1deg)}50%{-webkit-transform:rotate(0) scale(1) skew(1deg)}100%{-webkit-transform:rotate(0) scale(1) skew(1deg)}}@-o-keyframes dmd-circle-img-anim{0%{-o-transform:rotate(0) scale(1) skew(1deg)}10%{-o-transform:rotate(-25deg) scale(1) skew(1deg)}20%{-o-transform:rotate(25deg) scale(1) skew(1deg)}30%{-o-transform:rotate(-25deg) scale(1) skew(1deg)}40%{-o-transform:rotate(25deg) scale(1) skew(1deg)}50%{-o-transform:rotate(0) scale(1) skew(1deg)}100%{-o-transform:rotate(0) scale(1) skew(1deg)}}</style><a href=\"#\" onclick='call30s({\"action\": \"close\", \"width\": \"600\"})' class='call-fixed dmd-phone dmd-green dmd-show mobile' title='Gá»i miá»…n phĂ­''> <div class='dmd-ph-circle'></div><div class='dmd-ph-circle-fill'></div><div class='dmd-ph-img-circle'></div></a>";
            }
            section_30s.innerHTML =
                section_call +
                "<style>.call-fixed {display:block !important}; #popup-close {position: absolute; top: 2px;right: 3px; font-weight: bold;padding: 4px 6px;border: 1px solid #5d5555; border-radius: 50%; font-size: 10px; color: #5d5555; cursor: pointer;}#purple_chat_30s:hover {animation: none;}#purple_chat_30s { cursor:pointer;animation: shake 2.82s infinite cubic-bezier(.36,.07,.19,.97) both; transform: translate3d(0, 0, 0); backface-visibility: hidden; perspective: 1000px; } @keyframes delay {} @keyframes shake { 10%, 90% { transform: translate3d(-1px, 0, 0); } 20%, 80% { transform: translate3d(2px, 0, 0); } 30%, 50%, 70% { transform: translate3d(-4px, 0, 0); } 40%, 60% { transform: translate3d(4px, 0, 0); } }#popup_chat_30s {position: fixed;z-index: 999999999;right: 4px;bottom: 100px;width: 380px;}#popup_chat_30s .popup-group {margin-bottom: 6px;width: 100%;display: flex;}#popup_chat_30s .popup-group .popup-image {width: 50px;}#popup_chat_30s .popup-group .popup-message {box-shadow: 0 0  10px 0 #bbb;font-size:14px;box-sizing: border-box;width: calc(100% - 50px);background: #fff;padding: 10px;border-radius: 5px;}#popup_chat_30s .popup-group .popup-message .message-info{font-size: 12px;color: #aaaaaa;margin-top: 5px;} #popup_chat_30s .popup-group .popup-image img {border-radius: 50%;padding: 2px;background: #fff;width: 35px;height: 35px;}#popup_image_right, #popup_image_none_right {display:none; text-align:right;}#popup_chat_30s .popup-group .popup-message input{border: 0;outline: unset;font-size:14px;width: 100%; margin: 0; box-shadow: 0 0 0 0} @media only screen and (max-width: 420px) { #popup_chat_30s, #support_chat_30s {width: calc(100% - 8px) !important} } #bg_chat_30s { z-index: 999999; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); display: none; }</style><div id='popup_chat_30s'></div><div id='purple_chat_30s' style='display:block;position:fixed;top:150px;right:20px;z-index:9999999;max-width:150px;max-height:150px;'></div><div name='support_chat_30s' hide='0' id='support_chat_30s' style='margin:0px !important;overflow: hidden;box-sizing:border-box;z-index:9999998;width:" +
                (self.config_chat_30s.width + 6) +
                " !important;height:" +
                self.config_chat_30s.height +
                "px;position:fixed;bottom:-999px;border:none;display:none;'></div><div id='bg_chat_30s'></div>";
            document.getElementById("support_chat_30s").innerHTML =
                self.slide_chat +
                "<iframe allow='camera *;microphone *' id='ifr_chat' width='100%' height='100%' src='https://" +
                host_30s +
                "/index.php?client_30s=" +
                self.client_30s +
                "&call=" +
                call +
                "&ref_token=" +
                ref_token +
                "&ref_token_detail=" +
                ref_token_detail +
                "&device=" +
                self.config_chat_30s.device +
                "&last_token=" +
                last_token +
                "&lang=" +
                chat_lang +
                "&id=" +
                self.id_admin +
                "&secret=" +
                self.secret_admin +
                "&width=" +
                window.innerWidth +
                "&height=" +
                window.innerHeight +
                "&domain=" +
                encodeURIComponent(window.location.origin) +
                "&url=" +
                encodeURIComponent(window.location.href) +
                "' style='border:0px;padding:0px;margin:0px;overflow: hidden; width:100% !important; height:100% !important;'></iframe>";
            document.getElementById("support_chat_30s").style.display = "block";
            document.getElementById("bg_chat_30s").addEventListener("click", function (event) {
                self.sendMessageLiveChat({ action: "close_phonebox" });
            });
            document.getElementById("purple_chat_30s").addEventListener("click", function() {
                self.purple_chat_30s()
            });
            setTimeout(function () {
                self.flag_completed = 1;
                if (document.getElementsByClassName("call-fixed").length > 0) {
                    document.getElementsByClassName("call-fixed")[0].style.display = "block";
                }
                if (document.getElementsByClassName("chat-fixed").length > 0) {
                    document.getElementsByClassName("chat-fixed")[0].style.display = "block";
                }
            }, 1e3);
        }, 1e3);
        this.title = document.title;
    };
}




// WEBPACK FOOTER //
// ./src/assets/js/chatLive.js